export default __webpack_public_path__ + "static/media/Group 5634.192dabd4.svg";